import axios from "axios";
const API_URL = "https://api.open-meteo.com/v1/forecast";

const getWeatherData = async ({ latitude, longitude }) => {
  const response = await axios.get(
    `${API_URL}?latitude=${latitude}&longitude=${longitude}&daily=temperature_2m_min,temperature_2m_max,weathercode&timezone=auto`
  );
  return response.data;
};

const weatherWidgetService = {
  getWeatherData
};

export default weatherWidgetService;
